import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=05289d69"
import script from "./ContentComponent.ts?vue&type=script&lang=js&external"
export * from "./ContentComponent.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports